import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { updatePromoCampaign } from '~/services/LuxLoyaltyService';

import type { PromoCampaignUpdateBody } from '~/types/loyaltyContract';

import { promoCampaignQueryKeys } from './promoCampaignQueryKeys';

interface UpdatePromoCampaignParams {
  promoCampaignId: string;
  campaign: PromoCampaignUpdateBody;
  addUserIds?: Array<string>;
}

export function useUpdatePromoCampaign() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ promoCampaignId, campaign, addUserIds }: UpdatePromoCampaignParams) => {
      return await updatePromoCampaign(promoCampaignId, { campaign, addUserIds });
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: promoCampaignQueryKeys.all });
      enqueueSnackbar('Promo campaign updated successfully', { variant: 'success' });

      const stats = response.result.assignmentStats;
      if (stats.received > 0 || stats.created > 0 || stats.duplicatesSkipped > 0) {
        enqueueSnackbar(
          `Assignment stats - received: ${stats.received}, created: ${stats.created}, duplicates skipped: ${stats.duplicatesSkipped}`,
          { variant: 'info' },
        );
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error updating promo campaign: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
